export default __webpack_public_path__ + "static/media/attendance.19514f34.svg";